<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.component('v-select', vSelect)

// register the plugin on vue
import Toasted from 'vue-toasted';

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Vehiculos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout, PageHeader,Loader,Vuetable,VuetablePagination, "fulfilling-bouncing-circle-spinner":FulfillingBouncingCircleSpinner,},
  data() {
    return {
        repit : true,
        userT : this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL +"autos/get",
       css: {
      table: {
        tableClass: 'table table-striped table-bordered table-hovered',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      pagination: {
        infoClass: 'pull-left',
        wrapperClass: 'vuetable-pagination pull-right',
        activeClass: 'btn-primary',
        disabledClass: 'disabled',
        pageClass: 'btn btn-border',
        linkClass: 'btn btn-border',
        icons: {
          first: '',
          prev: '',
          next: '',
          last: '',
        },
      }
    },
      formAuto: {
        auto: "",
        modelo: "",
        linea:"",
        serie:"",
        modelos: [],
        id: 0,
        state: true,
      },
      updating: false,
      estadotabla:true,
      title: "Vehiculos",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Vehiculos",
          active: true,
        },
      ],
      fields: [
        {
          name: 'nombre_auto',
          title: 'Nombre',
          sortField: 'nombre_auto',
          width: "80%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        }
      ],
       searchType: [
        { nombre: "Nombre", value: "nombre" },
      ],
      options : {
          theme: "outline",  
          position: "top-right", 
          duration : 5000,
          keepOnHover:true,
          action : {
            text : 'X',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
          },  
    },
      },
       loadingtable:false,
       sortBy: "nombre",
       sortDesc: false,
       searchLabel: { nombre: "Nombre", value: "nombre" },
       filterLabel: { nombre: "Nombre", value: "nombre" },
       showModalL: false, //Loading
       showModalE: false,  //Editar
       showModalN: false, //Nuevo registro
       showModalD: false, //Desactivar
       showModalA: false, //Activar
       data:[],
       pageOptions: [4, 10, 15, 20],
       search: "",
        page: 1,
        perPage: 4,
        from: 0,
        to: 0,
        total: 0,
        lastPage: 0,
    };
  },
  validations: {
    formAuto: {
      auto: { required,
        async isUnique (value) {
            if (value === '') return true
            let response = await axios.get( this.apiUrl +'autos/nombre_repetido?nombre='+ value  + '&id='+this.formAuto.id,{
            headers: { "x-token": this.userT.token}
          }).catch(console.log);
            this.repit = response.data.msg;
            return response.data.msg
          }   
      },
      modelos: { required },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
   
  },
   watch: {
  
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
  //Validaciones antes de guardar
     validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();
       if (this.formAuto.auto!= "" && this.repit == true) {
        if (opc=="update") {
         this.update();
       
        }
      }
      if (this.$v.$invalid && this.repit==false) {
        return;
      } else {
        this.showModalL= true;
        if (opc=="save") {
         this.save();
        }
      }
     
      
    },
    //Desactivar registro
    desactivate(){
    const {id,auto } =this.formAuto;
     axios
          .put(process.env.VUE_APP_URL + "autos/desactivate", {
            id: id,
          },{
            headers: { "x-token": this.userT.token}
          })
          .then(() => {
             this.showModalD = false;
             Vue.toasted.error((auto+" Desactivado"),this.options);
             this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
             Vue.toasted.error("Error para desactivar",this.options);
          });
    },
    //Activar registro
    activate(){
     const {id,auto  } =this.formAuto;
     axios
          .put(process.env.VUE_APP_URL + "autos/activate", {
            id: id,
          },{
            headers: { "x-token": this.userT.token}
          })
          .then(() => {
            this.showModalA = false;
            Vue.toasted.info((auto+" Activado"),this.options);
            this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
             Vue.toasted.error("Error para activar",this.options);
          });
    },
    //Guardar registro
    save(){
      const { auto, modelos } =this.formAuto;
      const me = this;
      axios
        .post(process.env.VUE_APP_URL + "autos/store", {
          nombre: auto,
          detalles: modelos,
        },{
            headers: { "x-token": this.userT.token}
          })
        .then(() => {
          Vue.toasted.success((auto+" Guardado"),this.options);
          me.$refs.vuetable.refresh();
          this.showModalN=false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
           Vue.toasted.error("Error para guardar",this.options);
        }).finally(() =>{
          this.showModalL= false;
        });
    },
 //ACtualizar registro
    update(){
      const { auto, id  } =this.formAuto;
      const me = this;
      axios
        .put(process.env.VUE_APP_URL + "autos/update", {
          id: id,
          nombre: auto
        },{
            headers: { "x-token": this.userT.token}
          })
        .then(() => {
          Vue.toasted.success((auto+" Actualizado"),this.options);
          me.$refs.vuetable.refresh();
          this.showModalE=false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Revise los datos!", error);
          Vue.toasted.error("Revise los datos para guardar",this.options);
        }).finally(() =>{
          this.showModalL= false;
        });
   
    },
   //Buscador dentro de la tabala
    onFiltered(){
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
   //enviar datos a la Paginacion
   onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
     //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
  //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
 openModal(model) {
      switch (model) {
        case "save": {
       this.$v.$reset();
      this.limpiarVariables();
         
          break;
        }
        case "update": {
       this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
limpiarVariables(){
   this.formAuto.id=0;
   this.formAuto.auto="";
   this.formAuto.modelo="";
   this.formAuto.modelos=[];
},
 //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
 closeModal(model) {
      switch (model) {
        case "save": {
         this.showModalN=false;
          this.showmodalL = false;
          break;
        }
         case "update": {
           this.showModalE=false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if(action=="edit-item"){
        this.formAuto.id=data.id;
        this.formAuto.auto=data.nombre_auto;
        
      }
       if(action=="new-item"){
          this.formAuto.id=0;
          this.formAuto.auto = "";
          this.formAuto.modelo="";
          this.formAuto.modelos=[];
      }
       if(action=="desactivate-item"){
        this.formAuto.auto=data.nombre_auto;
        this.formAuto.id=data.id;
        this.showModalD = true
      }
      if(action=="activate-item"){
        this.formAuto.auto=data.nombre_auto;
        this.formAuto.id=data.id;
        this.showModalA = true
      }
    },
    agregarsub() {
      this.$v.$touch();
      // if (this.formAuto.modelo != "" && this.formAuto.linea != "" && this.formAuto.serie) {
      if (this.formAuto.modelo != "" ) {
        this.formAuto.modelos.push({
          nombre: this.formAuto.modelo,
          linea: this.formAuto.linea,
          serie: this.formAuto.serie,
        });
        this.formAuto.modelo = "";
        this.formAuto.linea = "";
        this.formAuto.serie = "";
      }
    },
    eliminarSubpre(index) {
      let me = this;
      me.formAuto.modelos.splice(index, 1);
    },
  
  },
   computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  
    }
};
</script>
<style>
/* Css para el loading en el modal */
.my-class{
   background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
/*Para el icono */
.icon-content:hover i {
      color: #556ee6;
      -webkit-transform: scale(1.5);
              transform: scale(1.5); }
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">

        <!-- Loading -->      
            <b-modal
              centered
              v-model="showModalL"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
              no-close-on-backdrop
             content-class="my-class"
             header-class="my-class"
                  >
                    <template #modal-header="">
           
                  <h5></h5>
                </template>
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex justify-content-center">
                            
                         <fulfilling-bouncing-circle-spinner
                          :animation-duration="2000"
                          :size="90"
                          color="#2a3042"
                          />
                          </div>
                        </div>
                      
                       
                      </div>

                      
                    </form>
            </b-modal>

  <!-- Modal para Activar -->  
            <b-modal
              centered
              v-model="showModalA"
              title="Activar"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            
                          <h4>¿Desea Activar el Vehiculo {{this.formAuto.auto}}?</h4>
                            
                          </div>
                        </div>
                      
                       
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalA = false">Cancelar</b-button>
                         <b-button variant="danger" @click="activate">Activar</b-button>
                      </div>
                    </form>
            </b-modal>


 <!-- Modal para Desactivar -->  
            <b-modal
              centered
              v-model="showModalD"
              title="Desactivar"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            
                         <h4>¿Desea Desactivar el Vehiculo:  {{this.formAuto.auto}}?</h4>
                            
                          </div>
                        </div>
                      
                       
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalD = false">Cancelar</b-button>
                         <b-button variant="danger" @click="desactivate">Desactivar</b-button>
                      </div>
                    </form>
            </b-modal>



      <!-- Modal para Editar-->  
            <b-modal
              centered
              ref="modalUpdate"
              id="modalUpdate"
              title="Editar Vehiculo"
              no-close-on-backdrop
              v-model="showModalE"
              @hidden="closeModal('update')"
              @show="openModal('uptade')"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                              <label for="name">Nombre</label>
                              <input
                                id="name"
                                v-model="$v.formAuto.auto.$model"
                                type="text"
                                class="form-control"
                                placeholder="Ingrese un nombre"
                                :class="{
                                  'is-invalid': $v.formAuto.auto.$error,
                                }"
                                @input="$v.formAuto.auto.$touch()"
                              />
                              <div
                                v-if="  $v.formAuto.auto.$error &&!$v.formAuto.auto.required
                                "
                                class="invalid-feedback"
                              >
                                El nombre es obligatorio.
                              </div>
                              <div
                                v-if="!$v.formAuto.auto.isUnique"
                                :class="{
                                  'invalid-feedback': !$v.formAuto.auto.isUnique,
                                }"
                              >
                                  El nombre del auto {{formAuto.auto}} ya existen en nuestros registros.
                              </div>
                            </div>
                        </div>
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light"  @click="showModalE = false">Cerrar</b-button>
                        <b-button @click="validaciones('update')" variant="success" class="ms-1"
                          >Guardar</b-button
                        >
                      </div>
                    </form>
            </b-modal>

        <!-- Modal de Nuevo Registro-->  
            <b-modal
              size="lg"
              centered
              @show="openModal('save')"
              @hidden="openModal('save')"
              v-model="showModalN"
              id="modalSave"
              ref="modalSave"
              title="Nuevo Vehiculo y Modelos"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form >
                      <div class="row">
                        <div class="col-12">
                           <div class="mb-3">
                              <label for="name">Nombre</label>
                              <input
                                id="name"
                                v-model="$v.formAuto.auto.$model"
                                type="text"
                                class="form-control"
                                placeholder="Ingrese un nombre"
                                :class="{
                                  'is-invalid': $v.formAuto.auto.$error,
                                }"
                                @input="$v.formAuto.auto.$touch()"
                              />
                              <div
                                v-if="  $v.formAuto.auto.$error &&!$v.formAuto.auto.required
                                "
                                class="invalid-feedback"
                              >
                                El nombre es obligatorio.
                              </div>
                              <div
                                v-if="!$v.formAuto.auto.isUnique"
                                :class="{
                                  'invalid-feedback': !$v.formAuto.auto.isUnique,
                                }"
                              >
                                  El nombre  {{formAuto.auto}} ya existen en nuestros registros.
                              </div>
                            </div>
                        </div>
                      
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="name">Datos del modelo</label>
                            <b-input-group  class="mt-3">
                            <b-form-input 
                              id="nombre"
                              v-model="formAuto.modelo"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese modelo"
                            ></b-form-input>
                            <!-- <b-form-input 
                              id="nombre"
                              v-model="formAuto.linea"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese linea"
                            ></b-form-input>
                            <b-form-input 
                              id="nombre"
                              v-model="formAuto.serie"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese serie"
                            ></b-form-input> -->
                            <b-input-group-append>
                              <b-button variant="info"  @click="agregarsub">Agregar</b-button>
                            </b-input-group-append>
                          </b-input-group>
                          
                          </div>
                        </div>
                         <div class="col-12">
                            <div class="mb-3">
                              <b-table-simple responsive>
                                <b-thead>
                                  <tr>
                                    <th>Acciones</th>
                                    <th>No.</th>
                                    <th>Modelo</th>
                                    <!-- <th>Linea</th>
                                    <th>Serie</th> -->
                                  </tr>
                                </b-thead>
                                <b-tbody>
                                  <b-tr v-for="(item, index) in formAuto.modelos" :key="index">
                                    <b-th>
                                      <b-button
                                        tabindex="0" v-b-tooltip.focus title="Eliminar"
                                        class="icon-content col-xl-4 col-lg-4 col-sm-6"
                                      
                                        size="sm"
                                        variant="outline-danger"
                                        @click="eliminarSubpre(index)"
                                        > <i class="bx bx-trash-alt"
                                      /> </b-button>
                                    </b-th>
                                    <b-td>{{ index + 1 }}</b-td>
                                    <b-td >{{ item.nombre }}</b-td>
                                    <!-- <b-td >{{  item.linea}}</b-td>
                                    <b-td >{{ item.serie }}</b-td> -->
                                  </b-tr>
                                </b-tbody>
                             </b-table-simple>
                              <div
                              :class="{
                                'invalid-feedback': true,
                                'd-block':
                                  $v.formAuto.modelos.$error && !$v.formAuto.modelos.required,
                              }"
                            >
                              Debe Agregar modelos
                            </div>
                            </div>
                        </div>
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalN = false">Cerrar</b-button>
                        <b-button @click="validaciones('save')" variant="success" class="ms-1"
                          >Guardar</b-button
                        >
                      </div>
                    </form>
            </b-modal>

         <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Vehiculos</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2 ">
                    <div id="tickets-table_length" class="dataTables_length text-md-end ">
                      <label class="d-inline-flex align-items-center">
                         
                        <b-dropdown
                          v-if="searchType"
                          id="ddown1"
                          size="sm" 
                        >
                         <template v-slot:button-content>
                                    {{'Ordenar por: '+ searchLabel.nombre}}
                                    <i class="mdi mdi-chevron-down"></i>
                          </template>
                          <b-dropdown-item
                            v-for="(search, index) in searchType"
                            :key="index"
                            @click="changeTypeSearch(search)"
                            >{{ search.nombre }}</b-dropdown-item
                          >
                        </b-dropdown>
                      </label>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-3 text-md-start">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          v-model="search"
                          type="search"
                          @input="onFiltered()"
                          placeholder="Buscar..."
                          class="form-control form-control-sm "
                        ></b-form-input>
                      </label>
                    </div>
                  </div>


               <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                   <button
                   v-b-modal.modalSave
                    type="button"
                    class="btn btn-success btn-rounded mb-2 me-2"
                     @click="onActionClicked('new-item')"
                  >
                    <i class="mdi mdi-plus me-1"></i> Agregar
                  </button>
                  </label>
                </div>
                
              </div>

           
              <!-- End search -->
            </div>
            <!-- Table -->
        <Loader :loading="loadingtable">
          <vuetable ref="vuetable"
           class="table-divided table-responsive order-with-arrow"
            :css="css.table"
           :api-url="apiBase"
           :http-options="httpOptions"
            :reactive-api-url="true"
            :fields="fields"
            :per-page="perPage"
            :query-params="makeQueryParams"
            pagination-path
            @vuetable:pagination-data="onPaginationData">
            <div slot="actions" slot-scope="props">
               <b-button-group class="mt-4 mt-md-0">
                  <b-button v-if="props.rowData.estado_auto" tabindex="0" v-b-tooltip.focus title="Editar" variant="outline-primary"
                   v-b-modal.modalUpdate
                    @click="onActionClicked('edit-item', props.rowData)"
                  ><i class="bx bx-edit-alt"></i>
                  </b-button>

                  <router-link
                    :to="{
                      name: 'autosdetail',
                      params: { id: props.rowData.id },
                    }"
                  >
                    <b-button v-if="props.rowData.estado_auto" tabindex="0" v-b-tooltip.focus title="Ver Mas" variant="outline-secondary"
                    ><i class="bx bxs-show"></i>
                    </b-button>
                  </router-link>
                  <b-button tabindex="0" v-b-tooltip.focus title="Cambiar Estado" :variant="
                   props.rowData.estado_auto==true
                   ? 'outline-danger'
                    : 'outline-success'
                  "
                   @click="
                  props.rowData.estado_auto == true
                    ? onActionClicked('desactivate-item', props.rowData)
                    : onActionClicked('activate-item', props.rowData);
                "
                  >
                  <i :class="
                  props.rowData.estado_auto == true
                      ? 'bx bx-trash-alt'
                      : 'bx bx-list-check'"></i>
                  </b-button>
                
                

                 
               </b-button-group>
            </div>

            <div slot="estado" slot-scope="props">
              <h5 v-if="props.rowData.estado_auto == true">
            
               <span class="badge bg-success ms-1"><strong>ACTIVO</strong></span>
            </h5>
            <h5 v-else>
               <span class="badge bg-danger ms-1"><strong>INACTIVO</strong></span>
            </h5>
             
             
            </div>


           
		</vuetable>
        <div style="padding-top:10px">
          <vuetable-pagination ref="pagination"
          :css="css.pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </div>
           
           </Loader>
           
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
